import {JsonObject, JsonProperty} from "json2typescript";

import {JsonPropertyEmpty} from "../../utils/json-util";
import {TemplateItem} from "./template-item";

@JsonObject("TemplateItemDetailOutput")
export class TemplateItemDetailOutput {
    @JsonProperty()
    public templateId: string = "";

    @JsonProperty()
    public itemId: string = "";

    @JsonProperty("itemLabel", String)
    public itemLabel: string = "";

    @JsonProperty("itemList", [TemplateItem])
    public itemList: TemplateItem[] = JsonPropertyEmpty;

    constructor(init?: Partial<TemplateItemDetailOutput>) {
        Object.assign(this, init);
    }
}
